import { get } from "lodash";
import { useState } from "react";
import { ESTABLISHMENTS } from "utils/constants";
import Button from "../Components/Button";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import Select from "../Components/Select";

function View({ contact, onSubmit, onBack, isFirstScreen }) {
  const [selectedValue, setSelectedValue] = useState({
    income: undefined,
    incomeType: undefined,
    activityTime: undefined,
    cappedIndex: undefined,
    establishment: get(contact, "fields.establishment"),
    situation: undefined,
    optMadelin: undefined,
  });

  return (
    <div className="solyon">
      <div className="solyon__container">
        <div className="solyon__wrapper">
          <Header
            title="Quel est votre établissement employeur ?"
            highlight="établissement employeur"
            subtitle="Informations de l’adhérent"
            onBack={isFirstScreen ? undefined : onBack}
          />
          <div className="solyon__body">
            <div className="grid--1 max-500">
              <Select
                options={ESTABLISHMENTS.map((value) => ({
                  label: value,
                  value,
                }))}
                placeholder={"Sélectionnez ..."}
                label={"Établissement employeur"}
                defaultValue={selectedValue.establishment}
                onChange={(value) =>
                  setSelectedValue((prev) => ({
                    ...prev,
                    establishment: value,
                  }))
                }
              />
            </div>

            <div className="solyon__body--actions">
              <Button
                type={"primary"}
                alignment={"center"}
                disabled={!selectedValue.establishment}
                onClick={() =>
                  onSubmit({
                    ...contact,
                    fields: {
                      ...get(contact, "fields", {}),
                      ...selectedValue,
                    },
                  })
                }
              >
                Continuer
              </Button>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default View;
